import IconHOC from '../IconHOC';

import { ReactComponent as Edit2Icon } from './edit2.svg';

export const Edit2 = IconHOC(Edit2Icon);
